import React, { Component } from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Modal, Select } from 'antd'
import { inquiryService } from '@services/api'
import { isObjEmpty } from '@utils/index'

@inject((store: any) => {
    const { userStore } = store

    return { userStore }
})
@observer
export default class ModalAssignUser extends Component<any, any> {
    state = {
        visibility: false,
        confirmLoading: false,
        assignedUser: null,
        error: null
    }
    componentDidMount() {
        this.setState({ assignedUser: this.props.assignedUser.id })
    }
    handleVisibility = () => {
        this.setState(prevState => ({ visibility: !prevState.visibility }))
    }
    handleUserChange = e => {
        this.setState({ assignedUser: e })
    }
    handleSubmitUser = async () => {
        if (this.state.assignedUser) {
            // const { pageIndex, filters } = this.props.inquiries;
            this.setState({ confirmLoading: true, error: undefined })
            inquiryService
                .updateInquiry({
                    id: this.props.id,
                    data: {
                        status: 'PROGRESS',
                        assignedUser: this.state.assignedUser
                    }
                })
                .then(res => {
                    this.setState({ confirmLoading: false, visibility: false })
                    // this.props.updateAction;
                    this.props.update()
                })
        } else {
            this.setState({ error: 'נא לבחור נציג' })
        }
    }
    render() {
        const { Option } = Select
        const { users } = toJS(this.props.userStore)
        const usersOptions = users.map((user, index) => (
            <Option key={index} value={user.id}>
                {user.full_name}
            </Option>
        ))
        return (
            <div>
                <div>
                    {isObjEmpty(this.props.assignedUser) && <div>{this.props.assignedUser.name}</div>}
                    <a
                        onClick={e => {
                            e.preventDefault()
                            this.handleVisibility()
                        }}
                        style={{ fontSize: '0.8rem', textDecoration: 'underline' }}
                    >
                        {isObjEmpty(this.props.assignedUser) ? 'החלף נציג' : 'הקצה נציג'}
                    </a>
                </div>

                <Modal
                    title="הקצאת נציג"
                    visible={this.state.visibility}
                    onOk={this.handleSubmitUser}
                    onCancel={this.handleVisibility}
                    confirmLoading={this.state.confirmLoading}
                    okText="הקצה נציג"
                    cancelText="ביטול"
                >
                    <Select
                        defaultValue={isObjEmpty(this.props.assignedUser) ? this.props.assignedUser.name : 'בחר נציג'}
                        onChange={e => this.handleUserChange(e)}
                        style={{ width: '100%' }}
                    >
                        {usersOptions}
                    </Select>
                    {this.state.error && <span style={{ color: 'red' }}>{this.state.error}</span>}
                </Modal>
            </div>
        )
    }
}
